import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes,BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import ScrollToTop from './modules/ScrollToTop'
import reportWebVitals from './reportWebVitals';
// Bootstrap Bundle icon
import "bootstrap-icons/font/bootstrap-icons.css";
// Bootstrap Bundle css
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'leaflet/dist/leaflet.css';

import { Provider } from "react-redux";
import {store} from './redux/store'
import { LocationProvider } from './contextapi/LocationContext';
import { LocationSendProvider } from './contextapi/SendLcationContaxt';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LocationSendProvider>
   
    <LocationProvider>
  
    <BrowserRouter>
    <ScrollToTop/>
    <App/>
    </BrowserRouter>
    
    </LocationProvider>
    </LocationSendProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
